export default __webpack_public_path__ + "static/media/file-folder_darkGray2.708f9b93.svg";